module.exports = __webpack_public_path__ + "static/c1-82292851f23de242beb8bd38eee88360.png";